import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { BtnIcon, CustomPanel, Loading, PageHeader, CustomDropdown } from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { getPickingsProntosParaDownload } from '../../../../services/api/https/system/system.http'
import { FaCloudDownloadAlt } from 'react-icons/fa'
import { buildUrlParaDownloadArquivoDeSeparacao } from '../../../../services/api/routes/system.routes'

function GerarArquivoSeparacao({ dispatch, history, selectedTp }) {
  // Vars

  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [pickings, setPickings] = useState([])

  useEffect(() => {
    fetchedPickings()
  }, [selectedTp])

  // Events
  const onDownloadClicked = picking => {
    try {
      if (!picking.selectedEquipe) throw new Error('Selecione a Equipe de Separação')
      const {
        selectedEquipe: { picking_id, pickingteam_id },
      } = picking
      const url = buildUrlParaDownloadArquivoDeSeparacao(selectedTp, picking_id, pickingteam_id)
      window.open(url)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onEquipeChange = (picking, value) => {
    const index = pickings.findIndex(p => p.id === picking.id)
    if (index !== -1) {
      const newPickings = [...pickings]
      newPickings[index].selectedEquipe = value
      setPickings(newPickings)
    }
  }
  // Helpers
  const fetchedPickings = async () => {
    try {
      !isLoading && setIsLoading(true)
      const fetchedEquipes = await getPickingsProntosParaDownload(selectedTp)
      setPickings(fetchedEquipes)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }

  // Templates
  const dataTable = (
    <DataTable value={pickings} emptyMessage={'Não existe Picking Cadastrado'}>
      <Column field="id" header="Código" style={tableCellCentered(80)} />
      <Column field="created_at" header="Created At" style={tableCellCentered()} />
      <Column field="name" header="Picking" />
      <Column
        header="Equipes"
        style={tableCellCentered(200)}
        body={picking => (
          <CustomDropdown
            optionLabel="pickingteam_name"
            options={picking.equipesTp}
            value={picking.selectedEquipe ? picking.selectedEquipe : ''}
            onChange={value => onEquipeChange(picking, value)}
          />
        )}
      />
      <Column
        header="Download"
        style={tableCellCentered()}
        body={picking => (
          <BtnIcon onClick={() => onDownloadClicked(picking)}>
            <FaCloudDownloadAlt size={18} />
          </BtnIcon>
        )}
      />
    </DataTable>
  )
  // Renders
  return (
    <React.Fragment>
      <PageHeader>
        S.13 - Gerar Arquivo de Separação - &nbsp;<strong>Emergência</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          {isLoading ? (
            <div className="text-center">
              <Loading />
            </div>
          ) : (
            dataTable
          )}
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(GerarArquivoSeparacao))
